import { BTText } from "@btnet/core-components";

import { BdsActionBar, BdsButtonGroup, BdsIconX, BdsRollupButton } from "@buildertrend/components";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTModal } from "commonComponents/btWrappers/BTModal/BTModal";
import PageTitle from "commonComponents/utilities/PageTitle/PageTitle";

interface ISpecificationUnpublishModalProps {
    visible: boolean;
    onClose: () => void;
    onUnpublish: () => Promise<void>;
    isSubmitting: boolean;
}

function SpecificationUnpublishModal({
    visible,
    onClose,
    onUnpublish,
    isSubmitting,
}: ISpecificationUnpublishModalProps) {
    const handleUnpublish = async () => {
        await onUnpublish();
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <BTModal
            data-testid="specificationUnpublishModal"
            visible={visible}
            useModalLayout
            beforeClose={handleClose}
            width="480px"
            centered
            className="SpecificationUnpublishModal"
        >
            <PageTitle title="Move Specification to draft" />
            <div className="flex flex-col w-full">
                <div className="flex flex-col gap-1">
                    <div className="flex flex-row justify-between grow">
                        <BTText text="Move Specification to draft" size="distinct-lg" />
                        <BTButton
                            data-testid="close"
                            onClick={handleClose}
                            icon={<BdsIconX />}
                            aria-label="Close move to draft specification modal"
                            type="tertiary"
                        />
                    </div>
                    <div className="flex flex-row py-2">
                        <BTText
                            text="Moving this Specification to draft will remove viewing access from all subs and clients. Are you sure?"
                            size="normal-md"
                        />
                    </div>
                </div>
                <div className="flex flex-row">
                    <BdsActionBar id="specsUnpublishModalFooter" testid="specsUnpublishModalFooter">
                        <BdsButtonGroup
                            id="specsUnpublishModalFooterButtonGroup"
                            testid="specsUnpublishModalFooterButtonGroup"
                            grow
                            flexAlign="end"
                        >
                            <BdsRollupButton
                                id="cancel"
                                testid="cancelUnpublishButton"
                                text="Cancel"
                                value="cancel"
                                onClick={handleClose}
                                disabled={isSubmitting}
                                displayType="secondary"
                            />
                            <BdsRollupButton
                                id="unpublish"
                                testid="unpublishButton"
                                text="Move to draft"
                                value="unpublish"
                                onClick={handleUnpublish}
                                disabled={isSubmitting}
                                loading={isSubmitting}
                                displayType="primary"
                            />
                        </BdsButtonGroup>
                    </BdsActionBar>
                </div>
            </div>
        </BTModal>
    );
}

export default SpecificationUnpublishModal;
